/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import * as actionsParameter from './../parameter/actions';
import { OrderActionTypes } from './types';
import api from '../../../services/api';

const erroMessage = "Ops! ocorreu um erro no servidor";

export function* orderListRequest({
  payload,
}: ActionType<typeof actions.orderList>) {
  try {
    //konsole.log('orderListRequest:', type, payload);
    const currentPage = payload.page ? payload.page : 1;
    const { data } = yield call(api.get, `order?limit=4&page=${currentPage}`, { params: payload.request });
    //konsole.log('orderListRequest: data', data);

    yield put(actions.orderListSuccess({
      ...data.data.orders,
      orders: data.data.orders.data
    }));
  } catch (err) {
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
    }
    yield put(actions.clearLoading());
    //konsole.log('orderListRequest: err', err);
  }
}

export function* orderRequest({
  payload,
}: ActionType<typeof actions.order>) {
  try {
    //konsole.log('orderByIdRequest:', type, payload);
    const { data } = yield call(api.get, `order/${payload.order_id}`);
    //konsole.log('orderByIdRequest: data', data);

    yield put(actions.orderSucess(data.data));
  } catch (err) {
    //konsole.log('orderByIdRequest: err', err);
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }))
    }
    yield put(actions.clearLoading());
  }
}

export function* orderCancelRequest({
  payload,
}: ActionType<typeof actions.orderCancelRequest>) {
  try {
    //konsole.log('orderByIdRequest:', type, payload);
    const { data } = yield call(api.post, `order/cancel/${payload.order_id}`, {});

    //konsole.log('orderByIdRequest: data', data);

    yield put(actions.orderCancelSuccess(data.data));
    yield put(actionsParameter.setMessageToast({ type: 'success', message: 'Pedido cancelado com sucesso!' }));

  } catch (err) {
    const error = err as any;
    //konsole.log('orderByIdRequest: err', err);
    if (error.response.status === 422) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: error.response.data.data || error.response.data.message }));
    } else if (error.response.status >= 500 && error.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
    }
    yield put(actions.clearLoading());
  }
}

export default all([
  takeLatest(OrderActionTypes.ORDER_LIST_REQUEST, orderListRequest),
  takeLatest(OrderActionTypes.ORDER_REQUEST, orderRequest),
  takeLatest(OrderActionTypes.ORDER_CANCEL_REQUEST, orderCancelRequest),
]);
